const PRODUCTION_ORIGIN = 'https://shixu.yourchatxuan.top'

/** The store app renders its bundled web files; only authenticated API calls go to the server. */
export function isBundledNative(): boolean {
  return typeof window !== 'undefined' && window.location.protocol === 'capacitor:' && window.location.hostname === 'localhost'
}

export function apiUrl(path: string): string {
  if (!path.startsWith('/api/')) throw new Error('无效的业务接口地址')
  return isBundledNative() ? `${PRODUCTION_ORIGIN}${path}` : path
}

export function realtimeUrl(): string {
  const url = new URL(apiUrl('/api/ws'), window.location.href)
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:'
  return url.href
}

export function publicAppUrl(path: string): string {
  return new URL(path, isBundledNative() ? PRODUCTION_ORIGIN : window.location.origin).href
}
